import axios from 'axios'
// import store from '@/store'
import { getToken } from '@/utils/auth'
import { urlParamsToObject } from '@/utils/tools'
import { md5 } from '@/utils/md5'
import sendError from '@/utils/sendError'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (getToken()) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  }

  let paras = {}; let appid = ''; let sign = ''
  try {
   
    //根据当前域名切换对应的api
   let hosts = JSON.parse(process.env.VUE_APP_API_HOSTS)
   if(!config.baseURL && hosts&&hosts.length>0){
       var apiModel = hosts.find(r=>r.path===location.pathname)
       if(!apiModel){
           let path = location.pathname.substr(1)
           let pathIndex = path.indexOf('/')
           if(pathIndex>0){
               path = path.substring(0,pathIndex)
           }

           apiModel = hosts.find(r=>r.path===`/${path.toLowerCase()}`)
           if(!apiModel){
               apiModel = hosts.find(r=>r.path===`/`)
           }
       }

       config.baseURL = apiModel.host||''
   }


    let isFormData = config.data instanceof FormData
    if (isFormData) {
      config.baseURL = store.state.system.nasFileHost
      return config
    }

    
    if (config.url && config.url.indexOf('?') > -1) {
      paras = {
        ...paras,
        ...urlParamsToObject(config.url.substring(config.url.lastIndexOf('?')))
      }
    }
    if (config.data) {
      // 去掉重复参数
      var urlKeys = Object.keys(paras).map(k => k.toLocaleLowerCase())
      var dataKeys = Object.keys(config.data).map(k => k.toLocaleLowerCase())
      var keys = dataKeys.filter(k => urlKeys.indexOf(k) > -1)
      keys.forEach((k) => {
        delete config.data[k]
      })

      paras = {
        ...paras,
        ...config.data
      }
    }
    // 去掉所有空格
    let txt = JSON.stringify(paras).replace(/\s/g, '')
    paras = JSON.parse(txt)
    let signPara = Object.keys(paras)
      .map(k => [k.toLocaleLowerCase(), k])
      .filter(k => k[0] !== 'appid' && k[0] !== 'sign')
      .sort((n, l) => {
        return n[0] > l[0] ? 1 : n[0] === l[0] ? 0 : -1
      })
      .map(t => {
        return [t[0], paras[t[1]]].join('=')
      })
    let signStr = `${signPara.join('&')}${store.state.system.appSecret}`
    sign = md5(signStr).toLocaleUpperCase()
    appid = store.state.system.appId
    // console.log('signStr',signStr)
  } catch (ex) {
    console.log(ex)
  } finally {
    config.headers['appid'] = appid
    config.headers['sign'] = sign
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    if (response && response.status === 229) {
      sendError(response.data, 'LimitFlow')
      response.data = {
        Msg: response.data
      }
      return response
    }
    if (!response || !response.data) {
      return response
    } else if (response.data.ErrorCode === 3) {
      window.location.href = '/login'
    } else if (response.data.ErrorCode !== 0 && /.*[\u4e00-\u9fa5]+.*/.test(response.data.Msg)) {
      // 错误消息弹出提示
      const chineseMsg = ['数据验证失败', '程序访问异常,请稍后重试！', '签名验证失败!', '未授权访问,请重新登陆！']
      const enMsg = ['Data verification failed', 'Program access is abnormal, please try again later!', 'Signature verification failed!', 'Unauthorized access, please login again!']
      switch (response.data.Msg) {
        case chineseMsg[0]:
          response.data.Msg = enMsg[0]
          break
        case chineseMsg[1]:
          response.data.Msg = enMsg[1]
          break
        case chineseMsg[2]:
          response.data.Msg = enMsg[2]
          break
        case chineseMsg[3]:
          response.data.Msg = enMsg[3]
        break
      }
    }
    return response
  },
  /**
  * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
  * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
  */
  //  const res = response.data;
  //     if (res.code !== 20000) {
  //       Message({
  //         message: res.message,
  //         type: 'error',
  //         duration: 5 * 1000
  //       });
  //       // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //         MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //           confirmButtonText: '重新登录',
  //           cancelButtonText: '取消',
  //           type: 'warning'
  //         }).then(() => {
  //           store.dispatch('FedLogOut').then(() => {
  //             location.reload();// 为了重新实例化vue-router对象 避免bug
  //           });
  //         })
  //       }
  //       return Promise.reject('error');
  //     } else {
  //       return response.data;
  //     }
  error => {
    console.log('ERROR', error)// for debug
    // if(err)
    // sendError('Links seem to get inaccessible.')
    // 暂时注释,隐藏错误提示信息
    return Promise.reject(error)
  })

export default service
